import {
  Cells,
  ClientAdjustmentKeys,
  ClientDuesKeys,
  ClientKeys,
  ContributorKeys,
  DistributorKeys,
  InvoiceKeys,
  LabelKeys,
  PaymentKeys,
  PlatformKeys,
  SalesDataKeys,
  SignupReqKeys,
  TrackIncomeKeys,
  UserKeys,
} from "../constant";

export const SalesDataColumn = [
  { key: SalesDataKeys.TITLE, header: "File Name", cell: Cells.FILE_ICON_CELL },
  { key: SalesDataKeys.DISTRIBUTOR, header: "Distributor" },
  { key: SalesDataKeys.PLATFORM, header: "Platform" },
  { key: SalesDataKeys.FROM_DATE, header: "From Date" },
  { key: SalesDataKeys.TO_DATE, header: "To Date" },
  {
    key: SalesDataKeys.FILE_SIZE,
    header: "File Size",
    cell: Cells.FILE_SIZE_CELL,
  },
  { key: SalesDataKeys.CREATED, header: "Uploaded", cell: Cells.DATE_CELL },
  { key: SalesDataKeys.COMMENT, header: "Comment" },
  {
    key: SalesDataKeys.STATUS,
    header: "Status",
    cell: Cells.UPLOAD_STATUS_CELL,
  },
];

export const TrackColumn = [
  {
    key: TrackIncomeKeys.TITLE,
    header: "Track Title",
    cell: Cells.MUSIC_ICON_CELL,
    width: 400,
  },
  { key: TrackIncomeKeys.ARTIST, header: "Artist" },
  { key: TrackIncomeKeys.LYRICISTS, header: "Lyricist" },
  { key: TrackIncomeKeys.COMPOSERS, header: "Composer" },
  { key: TrackIncomeKeys.LABEL_NAME, header: "Label" },
  // { key: TrackIncomeKeys.UPC, header: "UPC" },
  { key: TrackIncomeKeys.ISRC, header: "ISRC" },
  {
    key: TrackIncomeKeys.LINK,
    header: "Link",
    cell: Cells.LINK_CELL,
    width: 60,
  },
];

export const LabelColumn = [
  { key: LabelKeys.LABEL_NAME, header: "Label Name", cell: Cells.LABEL_CELL },
  { key: LabelKeys.COUNTRY, header: "Country" },
  {
    key: LabelKeys.INCOME_SHARE,
    header: "Income Share",
    cell: Cells.PERCENTAGE_TAG_CELL,
  },
  { key: LabelKeys.LABEL_STATUS, header: "Status", cell: Cells.STATUS_CELL },
  { key: LabelKeys.LABEL_MODIFIED, header: "Modified", cell: Cells.DATE_CELL },
];

const ContributorColumn = [
  {
    key: ContributorKeys.DATE_OF_BIRTH,
    header: "Date of Birth",
    cell: Cells.DATE_CELL,
  },
  { key: ContributorKeys.EMAIL, header: "Email Address" },
  { key: ContributorKeys.PHONE, header: "Phone Number" },
  { key: ContributorKeys.COUNTRY, header: "Country" },
  { key: ContributorKeys.CREATED_AT, header: "Created", cell: Cells.DATE_CELL },
];
export const ArtistColumn = [
  {
    key: ContributorKeys.NAME,
    header: "Artist Name",
    cell: Cells.USER_AVATAR_CELL,
  },
  ...ContributorColumn,
];
export const LyricistColumn = [
  {
    key: ContributorKeys.NAME,
    header: "Lyricist Name",
    cell: Cells.USER_AVATAR_CELL,
  },
  ...ContributorColumn,
];
export const ComposerColumn = [
  {
    key: ContributorKeys.NAME,
    header: "Composer Name",
    cell: Cells.USER_AVATAR_CELL,
  },
  ...ContributorColumn,
];
export const PlatformColumn = [
  {
    key: PlatformKeys.NAME,
    header: "Platform Name",
  },
  { key: PlatformKeys.CREATED_AT, header: "Created", cell: Cells.DATE_CELL },
  { key: PlatformKeys.MODIFIED, header: "Modified", cell: Cells.DATE_CELL },
];
export const DistributorColumn = [
  {
    key: DistributorKeys.NAME,
    header: "Distributor Name",
  },
  { key: DistributorKeys.CREATED_AT, header: "Created", cell: Cells.DATE_CELL },
  { key: DistributorKeys.MODIFIED, header: "Modified", cell: Cells.DATE_CELL },
];

export const AllIncomeColumn = [
  {
    key: TrackIncomeKeys.TITLE,
    header: "Track Title",
    cell: Cells.MUSIC_ICON_CELL,
    width: 320,
  },
  { key: TrackIncomeKeys.ARTIST, header: "Artist" },
  { key: TrackIncomeKeys.LYRICISTS, header: "Lyricist" },
  { key: TrackIncomeKeys.COMPOSERS, header: "Composer" },
  { key: TrackIncomeKeys.LABEL_NAME, header: "Label" },
  { key: TrackIncomeKeys.PLATFORM, header: "Platform" },
  { key: TrackIncomeKeys.DISTRIBUTOR, header: "Distributor" },
  { key: TrackIncomeKeys.QUANTITY, header: "Quantity", width: 100 },
  { key: TrackIncomeKeys.CURRENCY, header: "Currency", width: 80 },
  { key: TrackIncomeKeys.BASE_INCOME, header: "Income" },
  { key: TrackIncomeKeys.NET_INCOME, header: "Label Received" },
];

export const AllIncomeCLAPAdminCLAPManagerColumn = [
  {
    key: TrackIncomeKeys.TITLE,
    header: "Track Title",
    cell: Cells.MUSIC_ICON_CELL,
    width: 320,
  },
  { key: TrackIncomeKeys.ARTIST, header: "Artist" },
  { key: TrackIncomeKeys.LYRICISTS, header: "Lyricist" },
  { key: TrackIncomeKeys.COMPOSERS, header: "Composer" },
  { key: TrackIncomeKeys.LABEL_NAME, header: "Label" },
  { key: TrackIncomeKeys.PLATFORM, header: "Platform" },
  { key: TrackIncomeKeys.DISTRIBUTOR, header: "Distributor" },
  { key: TrackIncomeKeys.QUANTITY, header: "Quantity", width: 100 },
  { key: TrackIncomeKeys.CURRENCY, header: "Currency", width: 80 },
  { key: TrackIncomeKeys.CLAP_INCOME, header: "CLAP Income" },
  { key: TrackIncomeKeys.NET_INCOME, header: "Label Received" },
];

export const AllIncomeForAccountsColumn = [
  {
    key: TrackIncomeKeys.TITLE,
    header: "Track Title",
    cell: Cells.MUSIC_ICON_CELL,
    width: 320,
  },
  { key: TrackIncomeKeys.ARTIST, header: "Artist" },
  { key: TrackIncomeKeys.LYRICISTS, header: "Lyricist" },
  { key: TrackIncomeKeys.COMPOSERS, header: "Composer" },
  { key: TrackIncomeKeys.LABEL_NAME, header: "Label" },
  { key: TrackIncomeKeys.PLATFORM, header: "Platform" },
  { key: TrackIncomeKeys.DISTRIBUTOR, header: "Distributor" },
  { key: TrackIncomeKeys.QUANTITY, header: "Quantity", width: 100 },
  { key: TrackIncomeKeys.CURRENCY, header: "Currency", width: 80 },
  { key: TrackIncomeKeys.CLIENT_INCOME, header: "Client Income" },
  { key: TrackIncomeKeys.PAYABLE, header: "Client Receivable" },
];

export const ClientIncomeColumn = [
  ...AllIncomeColumn.slice(0, -2),
  { key: TrackIncomeKeys.NET_INCOME, header: "Track Income" },
  { key: TrackIncomeKeys.CLIENT_INCOME, header: "Client Income" },
  // { key: TrackIncomeKeys.PAYABLE, header: "Client Payable" },
];

export const ClientColumn = [
  // { key: ClientKeys.NAME, header: "Client", cell: Cells.CLIENT_LOGO_CELL },
  { key: ClientKeys.EMAIL, header: "Email Address" },
  /* {
    key: ClientKeys.CLIENT_TYPES,
    header: "Client Type",
    cell: Cells.CLIENT_TYPES_CELL,
  },
  {
    key: ClientKeys.INCOME_SHARE,
    header: "Income Share",
    // FIXME Should come array from backend to show multiple
    cell: Cells.MULTIPLE_PERCENTAGE_TAG_CELL,
    width: 252,
  },
  { key: ClientKeys.BDT_INCOME, header: "BDT", cell: Cells.BDT_CELL },
  { key: ClientKeys.EUR_INCOME, header: "EUR", cell: Cells.EUR_CELL },
  { key: ClientKeys.USD_INCOME, header: "USD", cell: Cells.USD_CELL }, */
  {
    key: ClientKeys.LAST_PAYMENT,
    header: "Last Payment",
    cell: Cells.DATE_CELL,
  },
  {
    key: ClientKeys.TOTAL_BDT_DUE,
    header: "Total Due",
    cell: Cells.TOTAL_DUE_CELL,
  }, // TODO its better to get a single key to show
  {
    key: ClientKeys.PAYMENT_CALCULATION_STATUS,
    header: "Payment Calculation Status",
    cell: Cells.UPLOAD_STATUS_CELL,
  },
];

export const ClientDuesColumn = [
  { key: ClientDuesKeys.MONTH, header: "Month" },
  { key: ClientDuesKeys.LAST_PAYMENT, header: "Last Payment", cell: "" },
  { key: ClientDuesKeys.EUR_DUE, header: "EUR", cell: Cells.EUR_CELL },
  { key: ClientDuesKeys.USD_DUE, header: "USD", cell: Cells.USD_CELL },
  { key: ClientDuesKeys.BDT_DUE, header: "BDT", cell: Cells.BDT_CELL },
];

export const PaymentsColumn = [
  {
    key: PaymentKeys.TITLE,
    header: "Payment Title",
    cell: Cells.PRIMARY_COLORED_CELL,
  },
  { key: PaymentKeys.CREATED, header: "Created", cell: Cells.DATE_CELL },
  { key: PaymentKeys.CLIENT, header: "Client" },
  {
    key: PaymentKeys.STATUS,
    header: "Status",
    cell: Cells.PAYMENT_STATUS_CELL,
  },
  { key: PaymentKeys.MODIFIED, header: "Modified", cell: Cells.DATE_CELL },
  { key: PaymentKeys.CURRENCY, header: "Currency" },
  { key: PaymentKeys.AMOUNT, header: "Amount" },
  { key: PaymentKeys.PAYABLE_BDT, header: "Payable (BDT)" },
];

export const ClientPaymentsColumn = [
  ...PaymentsColumn.slice(0, 2),
  ...PaymentsColumn.slice(3),
];

export const InvoicesColumn = [
  {
    key: InvoiceKeys.INVOICE_NO,
    header: "Invoice No.",
    cell: Cells.INVOICE_NO_CELL,
  },
  {
    key: InvoiceKeys.INVOICE_DATE,
    header: "Invoice Date",
    cell: Cells.DATE_CELL,
  },
  { key: InvoiceKeys.CLIENT, header: "Client" },
  {
    key: InvoiceKeys.STATUS,
    header: "Status",
    cell: Cells.INVOICE_STATUS_CELL,
  },
  // {
  //   key: InvoiceKeys.EXCHANGE_RATE_ADDED_DATE,
  //   header: "Exchange Rate Added",
  //   cell: Cells.DATE_CELL,
  // },
  {
    key: InvoiceKeys.REFERENCE,
    header: "Reference",
  },
  {
    key: InvoiceKeys.PAID_DATE,
    header: "Payment Date",
  },
  { key: InvoiceKeys.CURRENCY, header: "Currency" },
  {
    key: InvoiceKeys.INVOICE_AMOUNT,
    header: "Amount",
    cell: Cells.INVOICE_AMOUNT_CELL,
  },
  {
    key: InvoiceKeys.INVOICE_AMOUNT_BDT,
    header: "Invoice Amount (BDT)",
    cell: Cells.BDT_CELL,
  },
];

export const ClientInvoicesColumn = [
  ...InvoicesColumn.slice(0, 2),
  ...InvoicesColumn.slice(3, InvoicesColumn.length - 1),
  ...[
    {
      key: InvoiceKeys.EXCHANGE_RATE,
      header: "Exchange Rate",
      cell: Cells.EXCHANGE_RATE_CELL,
    },
    {
      key: InvoiceKeys.INVOICE_AMOUNT_BDT,
      header: "Invoice Amount (BDT)",
      cell: Cells.BDT_CELL,
    },
  ],
];

export const UserColumn = [
  { key: UserKeys.NAME, header: "Name", cell: Cells.USER_AVATAR_CELL },
  { key: UserKeys.USERNAME, header: "Username" },
  { key: UserKeys.CLIENT, header: "Client", cell: Cells.CLIENT_NAME_CELL },
  { key: UserKeys.EMAIL, header: "Email Address" },
  { key: UserKeys.USERROLE, header: "Role", cell: Cells.ROLE_CELL },
  { key: UserKeys.USER_STATUS, header: "Status", cell: Cells.STATUS_CELL },
  { key: UserKeys.DATE_JOINED, header: "Created", cell: Cells.DATE_CELL },
  { key: UserKeys.MODIFIED, header: "Modified", cell: Cells.DATE_CELL },
];

export const SignupReqColumn = [
  { key: SignupReqKeys.NAME, header: "Name", cell: Cells.PRIMARY_COLORED_CELL },
  {
    key: SignupReqKeys.CATEGORY_TYPE,
    header: "Category",
    cell: Cells.CLIENT_TYPES_CELL,
  },
  { key: SignupReqKeys.EMAIL, header: "Email Address" },
  { key: SignupReqKeys.PHONE, header: "Phone Number" },
  {
    key: SignupReqKeys.TOTAL_SONGS,
    header: "Total Songs",
  },
  {
    key: SignupReqKeys.POPULAR_SONGS,
    header: "Popular Songs",
  },
  {
    key: SignupReqKeys.STATUS,
    header: "Status",
    cell: Cells.SIGNUP_STATUS_CELL,
  },
  {
    key: SignupReqKeys.REQUESTED_DATE,
    header: "Requested Date",
    cell: Cells.DATE_CELL,
  },
];

export const SpecificTrackIncomeColumn = [
  { key: "tracks", header: "Track Title", cell: Cells.MUSIC_ICON_CELL },
  { key: "share", header: "Artist Income(%)" },
];

export const ClientAdjustmentColumn = [
  {
    key: ClientAdjustmentKeys.TRACK_TITLE,
    header: "Track Title",
    cell: Cells.MUSIC_ICON_CELL,
  },
  {
    key: ClientAdjustmentKeys.CURRENCY,
    header: "Currency",
  },
  {
    key: ClientAdjustmentKeys.ADJUSTMENT_AMOUNT,
    header: "Adjustment Amount",
  },
  {
    key: ClientAdjustmentKeys.REASON,
    header: "Reason",
  },
  {
    key: ClientAdjustmentKeys.CREATED,
    header: "Created",
    cell: Cells.DATE_CELL,
  },
];
